import * as Yup from 'yup';
import { DocumentVerificationStatusEnum } from 'api/actor';

/**
 * Yup schema for a CNI document slot held in Formik state.
 *
 * Two independent rules are enforced:
 * 1. A file must be present (either uploaded locally or already stored).
 * 2. The server-side verification must be finalised (status Verified).
 *
 * The second rule makes the form track the identity-verification lifecycle
 * exposed by the back-end (Pending / Rejected / Verified) and is surfaced
 * through standard Formik errors, so consumers like useTabErrors pick it up
 * automatically.
 */
export const cniValidation = Yup.object()
  .shape({
    storedFileId: Yup.string(),
    file: Yup.mixed(),
    verificationStatus: Yup.string()
  })
  .test(
    'cni-has-file',
    'Ce document est requis',
    value => !!(value?.storedFileId || value?.file)
  )
  .test(
    'cni-verified',
    "Vérification de l'identité en attente",
    value =>
      !value ||
      !(value.storedFileId || value.file) ||
      value.verificationStatus === DocumentVerificationStatusEnum.Verified
  );
